import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { LANDMARKS } from "../../data/project";

export default function Location() {
  return (
    <section
      id="location"
      data-testid="location-section"
      className="relative bg-[#1A3626] text-[#F4F2EC] py-24 md:py-36 overflow-hidden"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8 mb-14 md:mb-20">
          <div className="col-span-12 md:col-span-7">
            <div className="overline mb-5" style={{ color: "#B3906A" }}>
              05 / Location
            </div>
            <h2
              className="font-serif leading-[1.02] tracking-tight"
              style={{ fontSize: "clamp(40px, 5.5vw, 78px)" }}
            >
              Twenty minutes
              <br />
              from <span className="italic font-light">everywhere.</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-5">
            <p className="text-[#F4F2EC]/75 font-light leading-relaxed">
              Hudayriyat sits off Abu Dhabi's western coast, connected by
              causeway to the Corniche and Saadiyat. A private island
              experience with the access of a downtown address.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-6 md:gap-10">
          {/* Map embed */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="col-span-12 md:col-span-7 aspect-[16/11] overflow-hidden border border-[#F4F2EC]/15 relative"
          >
            <iframe
              title="Hudayriyat Island map"
              src="https://www.google.com/maps?q=Hudayriyat%20Island%2C%20Abu%20Dhabi&output=embed"
              className="w-full h-full"
              loading="lazy"
              style={{ filter: "grayscale(0.9) contrast(0.95) brightness(0.85)" }}
            />
            <div className="absolute top-5 left-5 bg-[#1A3626] border border-[#B3906A]/40 px-4 py-3">
              <div className="overline" style={{ color: "#B3906A" }}>
                Pin
              </div>
              <div className="mt-1 font-serif text-lg">Hudayriyat Island</div>
            </div>
          </motion.div>

          {/* Landmarks list */}
          <div className="col-span-12 md:col-span-5">
            <div
              className="overline mb-4"
              style={{ color: "rgba(244,242,236,0.55)" }}
            >
              Drive times
            </div>
            <ul className="divide-y divide-[#F4F2EC]/15 border-y border-[#F4F2EC]/15">
              {LANDMARKS.map((l, i) => (
                <motion.li
                  key={l.label}
                  data-testid={`landmark-${i}`}
                  initial={{ opacity: 0, x: 12 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.06 }}
                  className="flex items-center justify-between py-5"
                >
                  <span className="flex items-center gap-3 font-serif text-lg md:text-xl">
                    <MapPin
                      className="w-4 h-4 text-[#B3906A]"
                      strokeWidth={1.5}
                    />
                    {l.label}
                  </span>
                  <span className="text-[#B3906A] font-serif text-2xl tabular-nums">
                    {l.minutes}
                    <span className="text-sm text-[#F4F2EC]/55 ml-1.5">
                      min
                    </span>
                  </span>
                </motion.li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
